import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'leaseTerm' })
export class LeaseTermPipe implements PipeTransform {
  transform(months?: number): string | null {
    if (months === null || months === undefined) {
      return null;
    }

    return `${months} ${months === 1 ? 'month' : 'months'}`;
  }
}
